import React, { useContext } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useAppContext } from 'utils/hooks';
import { ReactComponent as LockIcon } from 'assets/img/icons/new/lock-icon.svg';

export default function ChangePasswordOption() {
  const { isSSRMode } = useAppContext();

  const { isExternalUser, toggleChangePasswordModal } = useContext(AuthContext);

  if (isSSRMode || isExternalUser) return null;

  return (
    <UiKit.Dropdown.Option onClick={toggleChangePasswordModal}>
      <LockIcon className={cn(styles.icon, styles.lockIcon)} />
      Change Password
    </UiKit.Dropdown.Option>
  );
}
